import axios from 'axios'
import {
    Notification,
    Message
} from 'element-ui'
import $store from '@/store'
import $router from '@/router'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: 'http://wdemo64.wyoucms.cn/',
    // 超时
    timeout: 100000
})

// request拦截器
service.interceptors.request.use(config => {
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false

    // 从localStorage获取token
    const token = localStorage.getItem('ToKen');
    if (token) {
        // 将token添加到请求头 Bearer
        // config.headers['Authorization'] = `${token}`;
        config.headers['token'] = `${token}`;
    }

    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        // 未设置状态码则默认成功状态
        const code = res.data.code;
        if (code === 401) {
            Message({message: res.data.msg || '登录失效请重新登录', type: 'error'})
            //清除缓存
            $store.commit('logout'); // 清除缓存
            $router.push({name: 'home'}); // 路由跳转
            return Promise.reject('登录失效请重新登录')
        } else if (code === 500) {
            Message({message: res.data.msg || '连接服务器失败', type: 'error'})
            return Promise.reject(new Error('连接服务器失败'))
            // return res.data
        } else if (code !== 200) {
            Notification.error({
                title: res.data.msg || 'connect failed'
            })
            return Promise.reject(new Error(res.data.msg || 'error'))
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error)
        let {
            message
        } = error;
        if (message == "Network Error") {
            message = "Abnormal backend interface connection";
        } else if (message.includes("timeout")) {
            message = "System interface request timeout";
        } else if (message.includes("Request failed with status code")) {
            message = "Interface " + message.substr(message.length - 3) + " abnormal";
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service
